/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-undef */
import SideBar from "../sidebar/SideBar";
import Header from "../header/Header";
import { Link, useParams } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { useEffect, useState } from "react";
import { FaCirclePlus, FaCircleMinus, FaPlus, FaMinus } from "react-icons/fa6";
import CountrySelectInput from "../shared/countrySelectInput";
import { addDoc, collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import { db, storage } from "../../config/firebase";
import { useMyContext } from "../../context/MyContext";
import {
  deleteObject,
  getDownloadURL,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import { Button, Flex, Progress, Select, Upload, message } from "antd";
import { countries } from "../shared/countrySelectInput/countries";
import {
  EditFilled,
  InboxOutlined,
  LoadingOutlined,
  StarOutlined,
} from "@ant-design/icons";
import DashboardLayout from "../layout";
import { downloadAttachment } from "../../utils/downloadAttachment";

function EditRequest() {
  const obj = {
    ative: true,
    content: " Shipment Details",
  };
  const { user } = useMyContext();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [totalWeight, setTotalWeight] = useState(0);
  const [creationDate, setCreationDate] = useState(new Date());
  const [eorGuarantee, setEorGuarantee] = useState(false);
  const [insureShipment, setInsureShipment] = useState(false);

  // console.log(user)
  const [Total, setTotal] = useState(0);

  const [formData, setFormData] = useState({
    status: "pending",
    name: user?.name || "",
    userId: user?.uid || "",
    email: user?.email || "",
    postalCode: user?.postalCode || "",
    address: user?.address || "",
    country: "",
    // loadName: '',
    loadMobileNo: "",
    loadAddress: "",
    loadAddress2: "",
    loadCountry: "",
    loadCity: "",
    loadPostalCode: "",
    loadAddress_CompanyName: "",
    unloadName: "",
    unloadMobileNo: "",
    unloadAddress: "",
    unloadAddress2: "",
    unloadCountry: "",
    unloadCity: "",
    unloadPostalCode: "",
    unloadAddress_CompanyName: "",
    pkgType: "",
    pcsPackage: [
      {
        quantity: "",
        weight: { value: "", unit: "Kg" },
        length: { value: "", unit: "cm" },
        width: { value: "", unit: "cm" },
        height: { value: "", unit: "cm" },
      },
    ],
    totalWeight: totalWeight,
    creationDate: creationDate.toISOString(),
    items: [
      {
        itemName: "",
        itemHSCode: "",
        itemValue: "",
        countryOrigin: "",
        quantity: "",
        hasHSCode: true,
      },
    ],
    total: Total,
    subTotal: 0,
    vatPercentage: 0,
    vatAmount: 0,
    currency: "USD",
    docFiles: [],
    manualDescription: "",
    requiredDoc: "",

    invoiceDetail: {
      invoiceFile: null,
      additionDetails: "",
    },
  });

  // console.log("formdata", formData);
  // const [hasHSCode, setHasHSCode] = useState(formData.items.hasHSCode);
  const allowedFileTypes = [
    "application/pdf",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "text/csv",
  ];

  const isFileAllowed = (file) => {
    return allowedFileTypes.includes(file.type);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userDocRef = doc(db, "requests", id);
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          const data = userDocSnap.data();
          setFormData(data);
          setEorGuarantee(data.eorGuarantee || false);
          setInsureShipment(data.insureShipment || false);
        } else {
          toast.error("Quote data not found");
        }
      } catch (error) {
        console.error("Error fetching Quote data:", error);
      }
    };

    fetchData();
  }, [id]);

  const [errors, setErrors] = useState({});
  const validateFields = () => {
    let isValid = true;
    let emptyFields = [];

    // List of mandatory fields
    const mandatoryFields = [
      "name",
      "loadAddress",
      "loadPostalCode",
      "loadCity",
      "loadCountry",
      "unloadName",
      "unloadAddress",
      "unloadPostalCode",
      "unloadCity",
      "unloadCountry",
    ];

    mandatoryFields.forEach((field) => {
      if (!formData[field] || formData[field].trim() === "") {
        isValid = false;
        emptyFields.push(field);
      }
    });

    // Check pcsPackage
    formData.pcsPackage.forEach((pkg, index) => {
      ["quantity", "weight", "length", "width", "height"].forEach((field) => {
        if (field === "quantity") {
          if (!pkg[field] || isNaN(pkg[field]) || parseFloat(pkg[field]) <= 0) {
            isValid = false;
            emptyFields.push(`pcsPackage-${index}-${field}`);
          }
        } else {
          if (
            !pkg[field] ||
            !pkg[field].value ||
            isNaN(pkg[field].value) ||
            parseFloat(pkg[field].value) <= 0
          ) {
            isValid = false;
            emptyFields.push(`pcsPackage-${index}-${field}`);
          }
        }
      });
    });

    // Check items
    formData.items.forEach((item, index) => {
      [
        "itemName",
        "itemValue",
        "countryOrigin",
        "quantity",
        "itemHSCode", // Add itemHSCode to the list
      ].forEach((field) => {
        if (field === "itemValue" || field === "quantity") {
          if (
            !item[field] ||
            isNaN(item[field]) ||
            parseFloat(item[field]) <= 0
          ) {
            isValid = false;
            emptyFields.push(`items-${index}-${field}`);
          }
        } else if (field === "itemHSCode") {
          // Special handling for itemHSCode
          if (
            item[field] &&
            (!/^\d+$/.test(item[field]) ||
              (item[field].length > 0 && item[field].length < 6))
          ) {
            isValid = false;
            emptyFields.push(`items-${index}-${field}`);
            toast.error(`HS Code for must be at least 6 digits or empty.`);
          }
        } else {
          if (
            !item[field] ||
            (typeof item[field] === "string" && item[field].trim() === "")
          ) {
            isValid = false;
            emptyFields.push(`items-${index}-${field}`);
          }
        }
      });
    });

    // Check mobile number lengths
    if (
      formData.loadAddress_PhoneNumber.length > 0 &&
      (formData.loadAddress_PhoneNumber.length > 20 ||
        !/^[+\d]*$/.test(formData.loadAddress_PhoneNumber))
    ) {
      isValid = false;
      emptyFields.push("loadAddress_PhoneNumber");
    }

    if (
      formData.unloadAddress_PhoneNumber.length > 0 &&
      (formData.unloadAddress_PhoneNumber.length > 20 ||
        !/^[+\d]*$/.test(formData.unloadAddress_PhoneNumber))
    ) {
      isValid = false;
      emptyFields.push("unloadAddress_PhoneNumber");
    }

    return { isValid, emptyFields };
  };

  const highlightEmptyFields = (emptyFields) => {
    emptyFields.forEach((field) => {
      const element = document.getElementById(field);
      if (element) {
        element.style.border = "2px solid red";
      }
    });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    if (name === "eorGuarantee") {
      setEorGuarantee(checked);
    } else if (name === "insureShipment") {
      setInsureShipment(checked);
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: checked,
    }));
  };

  useEffect(() => {
    // Calculate Sub Total
    const subTotal = formData.items.reduce((acc, item) => {
      const totalForItem =
        parseFloat(item.quantity || 1) * parseFloat(item.itemValue || 0);
      return acc + totalForItem;
    }, 0);

    // Format total to display only two decimal points
    const formattedTotal = subTotal.toFixed(2);

    // Update state
    // setTotal(formattedTotal);
    setFormData((prevData) => ({
      ...prevData,
      total: formattedTotal, // Update total
    }));
  }, [formData.items]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePcsOfPkgInput = (index, field, e) => {
    const { name, value } = e.target;

    // Prevent 'e', 'E', '+', and '-'
    if (/[eE+-]/.test(value)) {
      return;
    }
    // Convert to number and check if it's positive

    // Convert to number and check if it's not negative
    const numValue = Number(value);
    if (numValue < 0) {
      return;
    }

    setFormData((prevData) => {
      const newData = { ...prevData };
      const pcsPackage = [...newData.pcsPackage];

      if (pcsPackage[index]) {
        // Update the specific nested property (quantity, weight, length, width, height)
        if (field === "quantity") {
          pcsPackage[index][field] = value;
        } else {
          pcsPackage[index][field].value = value;
        }
      }

      newData.pcsPackage = pcsPackage;
      return newData;
    });
  };

  const handleUnitChange = (index, field, e) => {
    const { value } = e.target;

    setFormData((prevData) => {
      const newData = { ...prevData };
      const pcsPackage = [...newData.pcsPackage];

      // Ensure that pcsPackage array has an item at the specified index
      if (pcsPackage[index]) {
        // Update the unit value for the specified field
        pcsPackage[index][field].unit = value;
      }

      newData.pcsPackage = pcsPackage;
      return newData;
    });
  };

  const updateAllUnits = (unit) => {
    setFormData((prevData) => {
      const newData = { ...prevData };
      newData.pcsPackage = newData.pcsPackage.map((pkg) => ({
        ...pkg,
        length: { ...pkg.length, unit },
        width: { ...pkg.width, unit },
        height: { ...pkg.height, unit },
      }));
      return newData;
    });
  };

  useEffect(() => {
    const total = formData.pcsPackage.reduce((acc, pcs) => {
      const weightValue =
        parseFloat(pcs.quantity || 1) * parseFloat(pcs.weight.value || 0);
      return acc + weightValue;
    }, 0);

    setTotalWeight(total); // Update totalWeight state with numeric value
    setFormData((prevData) => ({
      ...prevData,
      totalWeight: total, // Set totalWeight field in formData with numeric value
    }));
  }, [formData.pcsPackage, totalWeight]);

  const handleRemovePcsOfpackage = () => {
    setFormData((prevData) => ({
      ...prevData,
      pcsPackage: prevData.pcsPackage.slice(0, -1), // Remove the last added package
    }));
  };
  const handleAddMorePcsOfpackage = () => {
    setFormData((prevData) => ({
      ...prevData,
      pcsPackage: [
        ...prevData.pcsPackage,
        {
          quantity: "", // Initialize quantity for each new item
          weight: { value: "", unit: "Kg" },
          length: { value: "", unit: "cm" },
          width: { value: "", unit: "cm" },
          height: { value: "", unit: "cm" },
        },
      ],
    }));
  };

  const handleRemoveService = () => {
    setFormData((prevData) => ({
      ...prevData,
      items: prevData.items.slice(0, -1), // Remove the last added service
    }));
  };

  const handleAddMore = () => {
    setFormData((prevData) => ({
      ...prevData,
      items: [...prevData.items, {}], // Update 'documents' to 'services'
    }));
  };

  const handleServiceInputChange = (index, field, e) => {
    const value = e.target.value;

    setFormData((prevData) => {
      const updatedItems = [...prevData.items];
      if (field === "hasHSCode") {
        updatedItems[index].hasHSCode = value === "yes";
        // If switching to "No", clear the HS Code
        if (value === "no") {
          updatedItems[index].itemHSCode = "";
        }
      } else {
        updatedItems[index][field] = value;
      }
      return {
        ...prevData,
        items: updatedItems,
      };
    });
  };
  const validateHSCode = (index) => {
    const item = formData.items[index];
    if (item.hasHSCode === null || item.hasHSCode === undefined) {
      setErrors((prev) => ({
        ...prev,
        [`hasHSCode-${index}`]: "Please select an option",
      }));
      return false;
    }
    if (item.hasHSCode === true) {
      if (!item.itemHSCode || item.itemHSCode.trim() === "") {
        setErrors((prev) => ({
          ...prev,
          [`itemHSCode-${index}`]: "HS Code is required",
        }));
        return false;
      }
      if (item.itemHSCode.length < 6) {
        setErrors((prev) => ({
          ...prev,
          [`itemHSCode-${index}`]: "HS Code must be at least 6 characters",
        }));
        return false;
      }
    }
    if (item.hasHSCode === false && (!formData.docFiles || formData.docFiles.length === 0)) {
      setErrors((prev) => ({ ...prev, [`docFiles-${index}`]: "Please upload a datasheet" }));
      return false;
    }
    setErrors((prev) => ({
      ...prev,
      [`hasHSCode-${index}`]: null,
      [`itemHSCode-${index}`]: null,
      [`docFiles-${index}`]: null,
    }));
    return true;
  };

  const handleAntdServiceInputChange = (index, field, value) => {
    setFormData((prevData) => {
      const updated = [...prevData.items];
      updated[index][field] = value;

      return {
        ...prevData,
        items: updated,
      };
    });
  };
  // console.log(formData)

  const handleAddData = async (e) => {
    e.preventDefault();
    if (disabled) return;
  
    const { isValid, emptyFields } = validateFields();
    if (!isValid) {
      toast.error("Please enter valid mobile number.");
      highlightEmptyFields(emptyFields);
      return;
    }
  
    let hasHSCodeErrors = false;
    let missingDatasheet = false;
  
    formData.items.forEach((item, index) => {
      if (!validateHSCode(index)) {
        hasHSCodeErrors = true;
      }
      if (item.hasHSCode === false && (!formData.docFiles || formData.docFiles.length === 0)) {
        missingDatasheet = true;
      }
    });
  
    if (hasHSCodeErrors) {
      toast.error("Please enter HS Code or upload datasheet for items without HS Code.");
      return;
    }
  
    if (missingDatasheet) {
      toast.error("Please upload a datasheet for items without HS Code.");
      return;
    }
  
    try {
      setLoading(true);
  
      const userDocRef = doc(db, "requests", id);
      await updateDoc(userDocRef, {
        ...formData,
        eorGuarantee,
        insureShipment,
      });
      toast.success("Data submitted successfully!");
      window.location.reload();
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Error saving data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handlePhoneNumberInput = (e) => {
    const { name, value } = e.target;
    const sanitizedValue = value.replace(/[^\d+]/g, "").slice(0, 20);
    const formattedValue = sanitizedValue.startsWith("+")
      ? sanitizedValue
      : sanitizedValue.replace(/^\+?/, "");

    setFormData((prevData) => ({
      ...prevData,
      [name]: formattedValue,
    }));
  };

  const [progress, setProgress] = useState(0);

  const handleFileUpload = async (file) => {
    if (file.status !== "remove") {
      if (!file) {
        console.error("No file selected.");
        return;
      }
      if (!isFileAllowed(file)) {
        message.error("Only PDF, Excel, and CSV files are allowed!");
        return;
      }
      setLoading(true);
      try {
        const storageRef = ref(storage, `invoviceFiles/${file.name}`);
        const uploadTask = uploadBytesResumable(storageRef, file);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progressPercentage =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setProgress(progressPercentage);
          },
          (error) => {
            setLoading(false);
            console.error("Error uploading file:", error);
            toast.error("Error uploading file: " + error.message);
          },
          async () => {
            const downloadURL = await getDownloadURL(storageRef);
            setFormData((prevData) => ({
              ...prevData,
              docFiles: [
                ...(prevData.docFiles || []),
                {
                  name: file.name,
                  url: downloadURL,
                  type: file.type,
                },
              ],
            }));
            setLoading(false);
            setProgress(100);
            setErrors((prev) => ({ ...prev, docFiles: null }));
            toast.success(`${file.name} uploaded successfully!`);
          }
        );
      } catch (error) {
        setLoading(false);
        console.error("Error uploading file:", error);
        toast.error("Error uploading file: " + error.message);
      }
    }
  };
  const handleRemove = async (file) => {
    try {
      const storageRef = ref(storage, `invoviceFiles/${file.name}`);
      await deleteObject(storageRef);
      setFormData((prevData) => ({
        ...prevData,
        docFiles: prevData.docFiles.filter((f) => f.name !== file.name),
      }));
      toast.success(`${file.name} deleted successfully`);
    } catch (error) {
      console.error("Error deleting file:", error);
      toast.error(`Error deleting file: ${error.message}`);
    }
  };
  const [disabled, setDisabled] = useState(true);
  return (
    <>
      <DashboardLayout>
        {/* <div className="hidden sm:block">
          <SideBar obj={obj} />
        </div> */}
        <div className="w-full border border-red">
          <Header title="Shipment Details" />
          <div className="p-4 bg-cus-gray">
            <div className="p-4 mx-auto bg-white border rounded-md">
              <div className="">
                <div>
                  <Flex justify="end" flex={"end"}>
                    <Button
                      type="primary"
                      danger={!disabled}
                      ghost={!disabled}
                      onClick={() => {
                        if (disabled) {
                          setDisabled(false);
                        } else {
                          const { isValid, emptyFields } = validateFields();
                          if (isValid) {
                            setDisabled(true);
                          } else {
                            toast.error("Please fill all mandatory fields");
                            highlightEmptyFields(emptyFields);
                          }
                        }
                      }}
                      icon={<EditFilled />}
                    >
                      {disabled ? "Edit" : " Preview Mode"}
                    </Button>
                  </Flex>
                  <div style={disabled ? { pointerEvents: "none" } : {}}>
                    {/* Collection */}
                    <h2 className="mx-[30px] font-bold text-xl mt-4">
                      Collection address{" "}
                    </h2>
                    <div className=" mx-[30px] grid md:grid-cols-2 grid-cols-1 gap-3">
                      <div className="flex flex-col gap-1 py-2">
                        <label
                          className="w-full text-sm font-normal "
                          htmlFor="name"
                        >
                          <span className="text-red-500">*</span> Name
                        </label>
                        <input
                          type="text"
                          className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          id="name"
                          name="name"
                          onChange={handleInputChange}
                          onFocus={(e) => (e.target.style.border = "")}
                          value={formData.name}
                        />
                      </div>

                      <div className="flex flex-col gap-1 py-2">
                        <label
                          className="w-full text-sm font-normal"
                          htmlFor="loadAddress"
                        >
                          Company Name
                        </label>
                        <input
                          type="text"
                          placeholder=" Company Name "
                          className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          name="loadAddress_CompanyName"
                          id="loadAddress_CompanyName"
                          onChange={handleInputChange}
                          value={formData.loadAddress_CompanyName}
                          onFocus={(e) => (e.target.style.border = "")}
                        />
                      </div>
                    </div>
                    <div className="mx-[30px] grid md:grid-cols-3 grid-cols-1 gap-3">
                      <div className="flex flex-col gap-1 py-2">
                        <label
                          className="w-full text-sm font-normal"
                          htmlFor="loadAddress"
                        >
                          <span className="text-red-500">*</span> Address line 1
                        </label>
                        <input
                          type="text"
                          placeholder="Address"
                          className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          name="loadAddress"
                          id="loadAddress"
                          onChange={handleInputChange}
                          value={formData.loadAddress}
                          onFocus={(e) => (e.target.style.border = "")}
                        />
                      </div>

                      <div className="flex flex-col gap-1 py-2">
                        <label
                          className="w-full text-sm font-normal"
                          htmlFor="loadAddress"
                        >
                          <span className="text-red-500">*</span> Zip Code
                        </label>
                        <input
                          type="text"
                          placeholder="Zip Code"
                          className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          name="loadPostalCode"
                          id="loadPostalCode"
                          onChange={handleInputChange}
                          value={formData.loadPostalCode}
                          onFocus={(e) => (e.target.style.border = "")}
                        />
                      </div>
                      <div className="flex flex-col gap-1 py-2 ">
                        <label
                          className="w-full text-sm font-normal"
                          htmlFor="loadAddress"
                        >
                          <span className="text-red-500">*</span> City
                        </label>
                        <input
                          type="text"
                          placeholder="city name"
                          className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          id="loadCity"
                          onChange={handleInputChange}
                          value={formData.loadCity}
                          name="loadCity"
                          onFocus={(e) => (e.target.style.border = "")}
                        />
                      </div>
                      <div className="flex flex-col gap-1 py-2">
                        <label
                          className="w-full text-sm font-normal"
                          htmlFor="loadAddress"
                        >
                          <span className="text-red-500">*</span> Load Country
                        </label>
                        <CountrySelectInput
                          label=""
                          onChange={handleInputChange}
                          value={formData.loadCountry}
                          name="loadCountry"
                          id="loadCountry"
                          onFocus={(e) => (e.target.style.border = "")}
                        />
                      </div>
                      <div className="flex flex-col gap-1 py-2">
                        <label
                          className="w-full text-sm font-normal "
                          htmlFor="Mblenum"
                        >
                          Mobile Number
                        </label>
                        <input
                          type="tel"
                          className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          name="loadAddress_PhoneNumber"
                          id="loadAddress_PhoneNumber"
                          onChange={handlePhoneNumberInput}
                          value={formData.loadAddress_PhoneNumber}
                          onFocus={(e) => (e.target.style.border = "")}
                          maxLength="20"
                        />
                      </div>
                    </div>
                    <h2 className="mx-[30px] font-bold text-xl mt-4">
                      Delivery address{" "}
                    </h2>
                    <div className=" mx-[30px] grid md:grid-cols-2 grid-cols-1 gap-3">
                      <div className="flex flex-col gap-1 py-2">
                        <label
                          className="w-full text-sm font-normal "
                          htmlFor="name"
                        >
                          <span className="text-red-500">*</span> Name
                        </label>
                        <input
                          type="text"
                          className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          id="unloadName"
                          name="unloadName"
                          onChange={handleInputChange}
                          value={formData.unloadName}
                          onFocus={(e) => (e.target.style.border = "")}
                        />
                      </div>

                      <div className="flex flex-col gap-1 py-2">
                        <label
                          className="w-full text-sm font-normal"
                          htmlFor="loadAddress"
                        >
                          Company Name
                        </label>
                        <input
                          type="text"
                          placeholder=" Company Name "
                          className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          name="unloadAddress_CompanyName"
                          id="unloadAddress_CompanyName"
                          onChange={handleInputChange}
                          value={formData.unloadAddress_CompanyName}
                          onFocus={(e) => (e.target.style.border = "")}
                        />
                      </div>
                    </div>
                    <div className="mx-[30px] grid md:grid-cols-3 grid-cols-1 gap-3">
                      <div className="flex flex-col gap-1 py-2">
                        <label
                          className="w-full text-sm font-normal"
                          htmlFor="loadAddress"
                        >
                          <span className="text-red-500">*</span> Address line 1
                        </label>
                        <input
                          type="text"
                          placeholder="Address"
                          className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          name="unloadAddress"
                          id="unloadAddress"
                          onChange={handleInputChange}
                          value={formData.unloadAddress}
                          onFocus={(e) => (e.target.style.border = "")}
                        />
                      </div>

                      <div className="flex flex-col gap-1 py-2">
                        <label
                          className="w-full text-sm font-normal"
                          htmlFor="loadAddress"
                        >
                          <span className="text-red-500">*</span> Zip Code
                        </label>
                        <input
                          type="text"
                          placeholder="Zip Code"
                          className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          name="unloadPostalCode"
                          id="unloadPostalCode"
                          onChange={handleInputChange}
                          value={formData.unloadPostalCode}
                          onFocus={(e) => (e.target.style.border = "")}
                        />
                      </div>
                      <div className="flex flex-col gap-1 py-2 ">
                        <label
                          className="w-full text-sm font-normal"
                          htmlFor="loadAddress"
                        >
                          <span className="text-red-500">*</span> City
                        </label>
                        <input
                          type="text"
                          placeholder="city name"
                          className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          id="unloadCity"
                          onChange={handleInputChange}
                          value={formData.unloadCity}
                          name="unloadCity"
                          onFocus={(e) => (e.target.style.border = "")}
                        />
                      </div>
                      <div className="flex flex-col gap-1 py-2">
                        <label
                          className="w-full text-sm font-normal"
                          htmlFor="loadAddress"
                        >
                          <span className="text-red-500">*</span> Country
                        </label>
                        <CountrySelectInput
                          label=""
                          onChange={handleInputChange}
                          value={formData.unloadCountry}
                          name="unloadCountry"
                          id="unloadCountry"
                          onFocus={(e) => (e.target.style.border = "")}
                        />
                      </div>
                      <div className="flex flex-col gap-1 py-2">
                        <label
                          className="w-full text-sm font-normal "
                          htmlFor="Mblenum"
                        >
                          Mobile Number
                        </label>
                        <input
                          type="tel"
                          className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          name="unloadAddress_PhoneNumber"
                          id="unloadAddress_PhoneNumber"
                          onChange={handlePhoneNumberInput}
                          value={formData.unloadAddress_PhoneNumber}
                          onFocus={(e) => (e.target.style.border = "")}
                          maxLength="20"
                        />
                      </div>
                    </div>
                    {formData.pcsPackage.map((formItem, index) => (
                      <div
                        key={index}
                        className="mx-[30px] flex-wrap justify-between flex items-center gap-5"
                      >
                        {/* Weight */}
                        <div className="w-full lg:w-[10%] flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor={`amount-${index}`}
                          >
                            Quantity<span className="text-red-500">*</span>
                          </label>
                          <input
                            type="number"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id={`pcsPackage-${index}-quantity`}
                            onChange={(e) =>
                              handlePcsOfPkgInput(index, "quantity", e)
                            }
                            value={formData.pcsPackage[index]?.quantity || ""}
                            onFocus={(e) => (e.target.style.border = "")}
                            onKeyDown={(e) => {
                              if (["e", "E", "+", "-"].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                        <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor={`weight-${index}`}
                          >
                            Weight<span className="text-red-500">*</span>
                          </label>
                          <div className="flex items-center">
                            <input
                              type="number"
                              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              name={`weight-${index}`}
                              id={`pcsPackage-${index}-weight`}
                              onChange={(e) =>
                                handlePcsOfPkgInput(index, "weight", e)
                              }
                              value={
                                formData.pcsPackage[index]?.weight.value || ""
                              }
                              onFocus={(e) => (e.target.style.border = "")}
                              onKeyDown={(e) => {
                                if (["e", "E", "+", "-"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            <select
                              className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              name={`weight-unit-${index}`}
                              id={`weight-unit-${index}`}
                              onChange={(e) =>
                                handleUnitChange(index, "weight", e)
                              }
                              value={
                                formData.pcsPackage[index]?.weight.unit || ""
                              }
                            >
                              <option value="kg">kg</option>
                              <option value="lbs">lbs</option>
                            </select>
                          </div>
                        </div>

                        {/* Length */}
                        <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor={`length-${index}`}
                          >
                            Length<span className="text-red-500">*</span>
                          </label>
                          <div className="flex items-center">
                            <input
                              type="number"
                              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              name={`length-${index}`}
                              id={`pcsPackage-${index}-length`}
                              onChange={(e) =>
                                handlePcsOfPkgInput(index, "length", e)
                              }
                              value={
                                formData.pcsPackage[index]?.length.value || ""
                              }
                              onFocus={(e) => (e.target.style.border = "")}
                              onKeyDown={(e) => {
                                if (["e", "E", "+", "-"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            <select
                              className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              name={`length-unit-${index}`}
                              id={`length-unit-${index}`}
                              onChange={(e) => {
                                handleUnitChange(index, "length", e);
                                updateAllUnits(e.target.value);
                              }}
                              value={
                                formData.pcsPackage[index]?.length.unit || ""
                              }
                            >
                              <option value="cm">cm</option>
                              <option value="in">in</option>
                            </select>
                          </div>
                        </div>
                        {/* Width */}
                        <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor={`width-${index}`}
                          >
                            Width<span className="text-red-500">*</span>
                          </label>
                          <div className="flex items-center">
                            <input
                              type="number"
                              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              name={`width-${index}`}
                              id={`pcsPackage-${index}-width`}
                              onChange={(e) =>
                                handlePcsOfPkgInput(index, "width", e)
                              }
                              onKeyDown={(e) => {
                                if (["e", "E", "+", "-"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              value={
                                formData.pcsPackage[index]?.width.value || ""
                              }
                              onFocus={(e) => (e.target.style.border = "")}
                            />
                            <select
                              className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              name={`width-unit-${index}`}
                              id={`width-unit-${index}`}
                              onChange={(e) => {
                                handleUnitChange(index, "width", e);
                                updateAllUnits(e.target.value);
                              }}
                              value={
                                formData.pcsPackage[index]?.width.unit || ""
                              }
                            >
                              <option value="cm">cm</option>
                              <option value="in">in</option>
                            </select>
                          </div>
                        </div>
                        {/* Height */}
                        <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor={`height-${index}`}
                          >
                            Height<span className="text-red-500">*</span>
                          </label>
                          <div className="flex items-center">
                            <input
                              type="number"
                              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              name={`height-${index}`}
                              id={`pcsPackage-${index}-height`}
                              onChange={(e) =>
                                handlePcsOfPkgInput(index, "height", e)
                              }
                              onKeyDown={(e) => {
                                if (["e", "E", "+", "-"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              value={
                                formData.pcsPackage[index]?.height.value || ""
                              }
                              onFocus={(e) => (e.target.style.border = "")}
                            />
                            <select
                              className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              name={`height-unit-${index}`}
                              id={`height-unit-${index}`}
                              onChange={(e) => {
                                handleUnitChange(index, "height", e);
                                updateAllUnits(e.target.value);
                              }}
                              value={
                                formData.pcsPackage[index]?.height.unit || ""
                              }
                            >
                              <option value="cm">cm</option>
                              <option value="in">in</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className="flex justify-between gap-5 items-center px-5 py-2">
                      <div className="flex gap-1 items-center">
                        <div
                          className={`mx-[20px] mt- ${
                            disabled
                              ? "opacity-50 cursor-not-allowed"
                              : "cursor-pointer"
                          }`}
                          onClick={() => {
                            if (!disabled) handleAddMorePcsOfpackage();
                          }}
                        >
                          <FaPlus className="text-[20px] text-[#03336E] " />
                        </div>

                        <div
                          className={`mx-[5px] ${
                            disabled
                              ? "opacity-50 cursor-not-allowed"
                              : "cursor-pointer"
                          }`}
                          onClick={() => {
                            if (!disabled) handleRemovePcsOfpackage();
                          }}
                        >
                          <FaMinus className="text-[20px] text-[#03336E] " />
                        </div>
                      </div>

                      <div className="px-5 flex  items-center gap-5">
                        <p className="text-[14px]"> Total Weight:</p>
                        <p className="text-[14px] font-extrabold">
                          {formData.totalWeight
                            ? formData.totalWeight
                            : totalWeight}
                        </p>
                      </div>
                    </div>
                    {/* {items} */}
                    <div className="flex flex-col md:w-1/2 py-3 gap-4 px-5">
                      <label
                        className="w-full text-sm font-normal "
                        htmlFor="username"
                      >
                        Select Package Type
                      </label>
                      <select
                        className="w-full  p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                        name="pkgType"
                        id="pkgType"
                        onChange={handleInputChange}
                        value={formData.pkgType}
                      >
                        <option value="pallet">Pallet </option>
                        <option value="box">Box</option>
                        <option value="container">Container</option>
                      </select>
                    </div>{" "}
                    <div className="mx-[30px] mt-2">
                      <Upload.Dragger
                        disabled={disabled}
                        multiple={true}
                        onChange={(info) => {
                          const { status } = info.file;
                          if (status !== "uploading") {
                            info.fileList.forEach((file) => {
                              if (!disabled && isFileAllowed(file)) {
                                handleFileUpload(file);
                              } else if (!isFileAllowed(file)) {
                                message.error(
                                  `${file.name} is not allowed. Only PDF, Excel, and CSV files are allowed!`
                                );
                              }
                            });
                          }
                        }}
                        onDrop={(e) => {
                          Array.from(e.dataTransfer.files).forEach((file) => {
                            if (!disabled && isFileAllowed(file)) {
                              handleFileUpload(file);
                            } else if (!isFileAllowed(file)) {
                              message.error(
                                `${file.name} is not allowed. Only PDF, Excel, and CSV files are allowed!`
                              );
                            }
                          });
                        }}
                        beforeUpload={(file) => {
                          if (!isFileAllowed(file)) {
                            message.error(
                              "Only PDF, Excel, and CSV files are allowed!"
                            );
                            return Upload.LIST_IGNORE;
                          }
                          return false;
                        }}
                        accept=".pdf,.xls,.xlsx,.csv"
                        name="files"
                      >
                        {progress < 100 && loading ? (
                          <div
                            style={{ textAlign: "center", marginTop: "20px" }}
                          >
                            <Progress
                              type="line"
                              percent={progress}
                              strokeWidth={2}
                              showInfo={false}
                            />
                          </div>
                        ) : (
                          <>
                            <p className="ant-upload-drag-icon">
                              <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">
                              Supporting Documents (E.G. Commercial Invoice,
                              Packing List, Datasheets)
                            </p>
                            <p className="ant-upload-hint">
                              Only PDF, Excel and CSV files are allowed
                            </p>
                          </>
                        )}
                      </Upload.Dragger>
                      {formData?.docFiles && formData.docFiles.length > 0 && (
                        <Upload
                          listType="picture"
                          fileList={formData.docFiles.map((file, index) => ({
                            uid: index,
                            name: file.name,
                            status: "done",
                            url: file.url,
                            type: file.type,
                          }))}
                          onRemove={handleRemove}
                          onPreview={(file) => {
                            const fileUrl = file.url;
                            if (!fileUrl) {
                              message.error("No file URL available for preview.");
                              return;
                            }
                            if (fileUrl.includes("firebasestorage.googleapis.com")) {
                              downloadAttachment(fileUrl, file.name).catch(() => {
                                toast.error("Unable to download file. Please try again.");
                              });
                              return;
                            }
                            if (
                              file.type === "application/pdf" ||
                              fileUrl.toLowerCase().endsWith(".pdf")
                            ) {
                              window.open(fileUrl, "_blank");
                            } else if (
                              file.type === "application/vnd.ms-excel" ||
                              file.type ===
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                              file.type === "application/vnd.ms-word" ||
                              file.type ===
                                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                              file.type === "text/csv" ||
                              fileUrl.toLowerCase().endsWith(".xls") ||
                              fileUrl.toLowerCase().endsWith(".xlsx") ||
                              fileUrl.toLowerCase().endsWith(".csv") ||
                              fileUrl.toLowerCase().endsWith(".docx") ||
                              fileUrl.toLowerCase().endsWith(".doc") ||
                              fileUrl.toLowerCase().endsWith(".docm") ||
                              fileUrl.toLowerCase().endsWith(".document")
                            ) {
                              const link = document.createElement("a");
                              link.href = fileUrl;
                              link.download = file.name;
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            } else {
                              message.error(
                                `Cannot preview this file type: ${file.type}`
                              );
                            }
                          }}
                        />
                      )}
                    </div>

                    
                    <div>
                      <div className="flex gap-5 items-center  mt-8">
                        <div className="mx-[30px] flex items-center gap-4">
                          <h2 className="text-xl font-bold ">Item details</h2>
                          <FaCirclePlus
                            className={`text-[22px] text-[#03336e] ${
                              disabled
                                ? "opacity-50 cursor-not-allowed"
                                : "cursor-pointer"
                            }`}
                            onClick={() => {
                              if (!disabled) handleAddMore();
                            }}
                          />
                        </div>
                        <div className=" flex items-center gap-2">
                          <h1 className="mt-2">Currency</h1>{" "}
                          {/* Fixed typo here */}
                          <select
                            className="ml-2 p-1 w-full text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            name="currency"
                            id="currency"
                            onChange={handleInputChange}
                            value={formData.currency}
                          >
                            <option value="USD">$USD</option>{" "}
                            {/* Changed value to "usd" for dollar */}
                            <option value="EUR">EUR</option>{" "}
                            {/* Changed value to "eur" for Euro */}
                          </select>
                        </div>
                      </div>
                      {formData.items.map((formItem, index) => (
                        <>
                          <div className="md:px-10" key={index}>
                            <h2 className="flex gap-3 items-center text-[16px] font-bold text-[gray] mt-6">
                              Item details
                              <FaCircleMinus
                                className={`${
                                  disabled
                                    ? "opacity-50 cursor-not-allowed"
                                    : "cursor-pointer"
                                }`}
                                onClick={() => {
                                  if (!disabled) handleRemoveService();
                                }}
                              />
                            </h2>
                            <div className="grid md:grid-cols-2 grid-cols-1 gap-3">
                              <div className="flex flex-col gap-1 py-2">
                                <label
                                  className="w-full text-sm font-normal "
                                  htmlFor="value"
                                >
                                  <span className="text-red-500">*</span> Item
                                  Name
                                </label>
                                <input
                                  type="text"
                                  className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                  id={`items-${index}-itemName`}
                                  onChange={(e) =>
                                    handleServiceInputChange(
                                      index,
                                      "itemName",
                                      e
                                    )
                                  }
                                  value={formItem.itemName}
                                  onKeyDown={(e) => {
                                    if (["e", "E", "+", "-"].includes(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onFocus={(e) => (e.target.style.border = "")}
                                />
                              </div>
                              <div className="flex flex-col gap-1 py-2">
                                <label
                                  className="w-full text-sm font-normal "
                                  htmlFor="value"
                                >
                                  <span className="text-red-500">*</span>{" "}
                                  Quantity
                                </label>
                                <input
                                  type="number"
                                  className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                  id={`items-${index}-quantity`}
                                  onChange={(e) =>
                                    handleServiceInputChange(
                                      index,
                                      "quantity",
                                      e
                                    )
                                  }
                                  value={formItem.quantity}
                                  onKeyDown={(e) => {
                                    if (["e", "E", "+", "-"].includes(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onFocus={(e) => (e.target.style.border = "")}
                                />
                              </div>
                            </div>

                            <div className=" grid md:grid-cols-2 grid-cols-1 gap-3">
                              <div className="flex flex-col gap-1 py-2">
                                <label
                                  className="w-full text-sm font-normal "
                                  htmlFor="value"
                                >
                                  <span className="text-red-500">*</span> Item
                                  Value
                                </label>
                                <input
                                  type="number"
                                  className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                  id={`items-${index}-itemValue`}
                                  onChange={(e) => {
                                    handleServiceInputChange(
                                      index,
                                      "itemValue",
                                      e
                                    );
                                  }}
                                  value={formItem.itemValue}
                                  onKeyDown={(e) => {
                                    if (["e", "E", "+", "-"].includes(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onFocus={(e) => (e.target.style.border = "")}
                                />
                              </div>
                              <div className="flex flex-col gap-1 py-2">
                                <label
                                  className="w-full text-sm font-normal "
                                  htmlFor="value"
                                >
                                  <span className="text-red-500">*</span>{" "}
                                  Country of Origin
                                </label>
                                <Select
                                  showSearch
                                  id={`items-${index}-countryOrigin`}
                                  options={countries?.map((country, index) => ({
                                    value: country,
                                    label: country,
                                    key: index,
                                  }))}
                                  onChange={(e) => {
                                    handleAntdServiceInputChange(
                                      index,
                                      "countryOrigin",
                                      e
                                    );
                                    document.getElementById(
                                      `items-${index}-countryOrigin`
                                    ).style.border = "";
                                  }}
                                  onFocus={() =>
                                    (document.getElementById(
                                      `items-${index}-countryOrigin`
                                    ).style.border = "")
                                  }
                                  value={formItem.countryOrigin}
                                />
                                {/* <input
                                  type="text"
                                  className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                  id={`countryOrigin-${index}`}
                                  onChange={(e) =>
                                    handleServiceInputChange(
                                      index,
                                      "countryOrigin",
                                      e
                                    )
                                  }
                                  value={formItem.countryOrigin}
                                /> */}
                              </div>
                              <div className="flex flex-col gap-1 py-2">
                                <label className="w-full text-sm font-normal">
                                  Do you have Item HS Code?{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <div className="flex gap-4">
                                  <label className="flex items-center">
                                    <input
                                      type="radio"
                                      name={`hasHSCode-${index}`}
                                      value="yes"
                                      checked={formItem.hasHSCode === true}
                                      onChange={(e) => {
                                        handleServiceInputChange(
                                          index,
                                          "hasHSCode",
                                          e
                                        );
                                        validateHSCode(index);
                                      }}
                                      className="mr-2"
                                      disabled={disabled}
                                    />
                                    Yes
                                  </label> 
                                  <label className="flex items-center">
                                    <input
                                      type="radio"
                                      name={`hasHSCode-${index}`}
                                      value="no"
                                      checked={formItem.hasHSCode === false}
                                      onChange={(e) => {
                                        handleServiceInputChange(
                                          index,
                                          "hasHSCode",
                                          e
                                        );
                                        validateHSCode(index);
                                      }}
                                      className="mr-2"
                                      disabled={disabled}
                                    />
                                    No
                                  </label>
                                </div>
                                {errors[`hasHSCode-${index}`] && (
                                  <p className="text-red-500 text-sm">
                                    {errors[`hasHSCode-${index}`]}
                                  </p>
                                )}
                                {formItem.hasHSCode === true && (
                                  <div className="mt-2">
                                    <label
                                      className="w-full text-sm font-normal"
                                      htmlFor={`items-${index}-itemHSCode`}
                                    >
                                      Item HS Code
                                    </label>
                                    <input
                                      type="number"
                                      className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
                                        errors[`itemHSCode-${index}`]
                                          ? "border-red-500"
                                          : ""
                                      }`}
                                      id={`items-${index}-itemHSCode`}
                                      onChange={(e) => {
                                        handleServiceInputChange(
                                          index,
                                          "itemHSCode",
                                          e
                                        );
                                        validateHSCode(index);
                                      }}
                                      value={formItem.itemHSCode}
                                      onKeyDown={(e) => {
                                        if (
                                          ["e", "E", "+", "-"].includes(e.key)
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                      min="0"
                                      onFocus={(e) =>
                                        (e.target.style.border = "")
                                      }
                                      onInput={(e) => {
                                        if (e.target.value.length > 14) {
                                          e.target.value = e.target.value.slice(
                                            6,
                                            20
                                          );
                                        }
                                      }}
                                      disabled={disabled}
                                    />
                                    {errors[`itemHSCode-${index}`] && (
                                      <p className="text-red-500 text-sm">
                                        {errors[`itemHSCode-${index}`]}
                                      </p>
                                    )}
                                  </div>
                                )}
                                {formItem.hasHSCode === false && (
                                  <div className="mt-2">
                                    <p className="text-sm mb-2">
                                      <span className="text-red-500">*</span>{" "}
                                      Please upload the datasheet for this
                                      product so we can classify your product.
                                    </p>
                                    {errors.docFiles && (
                                      <p className="text-red-500 text-sm">
                                        {errors.docFiles}
                                      </p>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      ))}
                      <div className="flex justify-end gap-5 mt-4 border-t border-cus-blue px-5">
                        <div className="mt-2">
                          <p className="text-[14px] font-medium">
                            Total Value :{" "}
                          </p>
                        </div>
                        <div className="mt-2">
                          <p className="text-[14px] font-extrabold ">
                            {formData.total} {formData.currency}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="border-t border-gray-200 my-4 pt-4 px-5">
                      <label className="block mb-2 text-sm font-normal text-black">
                        Additional details (optional)
                      </label>
                      <div className="w-full p-2 text-sm border border-gray-200 rounded-md bg-gray-50 min-h-[72px] whitespace-pre-wrap">
                        {formData.manualDescription || "—"}
                      </div>
                    </div>
                    <div className="flex flex-col px-5  gap-2">
                      <label
                        htmlFor="input-group-1"
                        className="block mb-2 text-lg font-normal text-black"
                      >
                        <span className="text-red-500">*</span> import
                        documentation required?
                      </label>
                      <div className="flex gap-2">
                        <label className="flex items-center">
                          <input
                            type="radio"
                            name="requiredDoc"
                            value="Required"
                            onChange={handleInputChange}
                            checked={formData.requiredDoc === "Required"}
                          />
                          <span className="ml-2">Required</span>
                        </label>
                        <label className="flex items-center">
                          <input
                            type="radio"
                            name="requiredDoc"
                            value="not_Required"
                            onChange={handleInputChange}
                            checked={formData.requiredDoc === "not_Required"}
                          />
                          <span className="ml-2">Not Required</span>
                        </label>
                        {/* Add more radio buttons as needed */}
                      </div>
                    </div>
                    <div className="mx-[30px] grid md:grid-cols-2 grid-cols-1 gap-3">
                      <div className="flex flex-col gap-1 py-2">
                        <label
                          className="w-full text-sm font-normal "
                          htmlFor="username"
                        >
                          <span className="text-red-500">*</span> Services
                        </label>
                        <select
                          placeholder="Select"
                          name="serviceType"
                          id="serviceType"
                          onChange={handleInputChange}
                          value={formData.serviceType}
                          className="w-full h-8 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                        >
                          <option value="">Select</option>{" "}
                          {/* Added value attribute to each option */}
                          <option value="EOR">EOR</option>
                          <option value="IOR">IOR</option>
                          <option value="White Glove">White Glove</option>
                        </select>
                      </div>
                    </div>
                    <div className="mx-[30px] py-4 w-full flex flex-col gap-3">
                      <div className="flex items-center gap-3">
                        <input
                          type="checkbox"
                          className="accent-blue-500 w-4 h-4"
                          id="insureShipment"
                          name="insureShipment"
                          checked={insureShipment}
                          onChange={handleCheckboxChange}
                          disabled={disabled}
                        />
                        <label
                          className="font-normal text-[10px] w-full"
                          htmlFor="insureShipment"
                        >
                          Insure this Shipment
                        </label>
                      </div>
                    </div>
                    {/* <div className="mx-[30px] py-4 w-full flex flex-col gap-3">
                                            <div className="flex items-center gap-3">
                                                <input type="checkbox" className="" />

                                                <label
                                                    className=" font-normal text-[10px] w-full"
                                                    htmlFor="chkbox"
                                                >
                                                    EOR guarantee
                                                </label>
                                            </div>

                                            <div className="flex items-center gap-3">
                                                <input type="checkbox" className="" />

                                                <label
                                                    className=" font-normal text-[10px] w-full"
                                                    htmlFor="chkbox"
                                                >
                                                    Insure this Shipment
                                                </label>
                                            </div>
                                            <div className="flex items-center gap-3">
                                                <input type="checkbox" className="" />
                                                <label
                                                    className=" font-normal text-[10px] w-full"
                                                    htmlFor="chkbox"
                                                >
                                                    By clicking i agree all terms and conditions.
                                                </label>
                                            </div>
                                        </div> */}
                    <div className=" flex justify-center items-center md:justify-start md:mx-[30px]">
                      {!disabled && (
                        <button
                          onClick={handleAddData}
                          className=" bg-cus-blue rounded-md text-white p-2 text-sm md:w-[341px] w-[180px] shadow-[#6478b0] shadow-lg"
                        >
                          {loading ? "Loading..." : "  Update Change "}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DashboardLayout>
    </>
  );
}

export default EditRequest;
